module.exports = __webpack_public_path__ + "media/images/favicon/favicon-1fa274976d496a6b6551af4e5623a16f.ico";